export default "__VITE_ASSET__CZtfFKeJ__"